export const BASEURL = "http://localhost:8383"
export const ELECTRONURL = "http://localhost:5555"
export const SERVERURL = window.location.hostname === "cryptodeputy.smallhost.pl" ? "https://cryptodeputy.smallhost.pl:44345" : "https://cryptodeputy.com:44344"
// export const SERVERURL = "http://localhost:44344"
export const HKEY = "7ISUKkFFUvkqgtGGz6x921qVYTXUKLkCyXkcp942bDckK0bqRz0K5ux1NDmKPjUa"